export const HEAD_KEY = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

export const API_ENDPOINTS = {
  CHECK_SESSION: "/checksession",
  // Add more endpoints as needed
};
